import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-branch-grid',
  templateUrl: './branch-grid.component.html',
  styleUrls: ['./branch-grid.component.css']
})
export class BranchGridComponent implements OnInit {
  title="Branch Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/view/branch-details/branch-grid/branch-grid.component.ts